module.exports = __webpack_public_path__ + "img/arrow-white.d81ed83f.svg";